import axios from "axios";
import API_BASE_URL from '../../config';

export const GetDataCoursesServices = async (token, idCourse) => {
  try {
    if (!token) {
      throw new Error("No token available");
    }

    const responseCourses = await axios.get(`${ API_BASE_URL }api/get-data-course/`,
        {
          params: {
            id_course: idCourse,
          },
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }
    )
  
    return responseCourses.data;

    } catch (error) {
      console.error('Error en la solicitud:', error.response ? error.response.data : error.message);
      throw error;
    }
};